// Theme (styled-components)
import colors from './colors';
import mediaQueries from './mediaQueries';
import fontSets from './fonts';

const theme = {
  colors,
  mediaQueries,
  fontSets,
};

export default theme;



// WEBPACK FOOTER //
// ./src/theme/corriere/index.js